module.exports = "/_next/static/images/categoryPlaceholder-d9298db55e241eb62a7de5563be3539a.svg";